import { ValidationSchema } from 'validation-schema-library';

const accountsValidationSchema: ValidationSchema = {
  azureId: {
    type: 'string',
  },
  extendedInformation: {
    type: 'object',
    properties: {
      financialInformation: {
        type: 'object',
        properties: {
          financialOneCId: {
            type: 'string',
          },
        },
      },
    },
  },
};

const getAccountsValidationSchema = () => Promise.resolve(accountsValidationSchema);

export default getAccountsValidationSchema;
